<div class="vehicle-detail-column">
  <div class="title">{{ vehicle?.title }}</div>
  <div class="user">
    <div *ngIf="vehicle?.driverName" class="driverName">
      {{ vehicle.driverName }}
    </div>
    <div *ngIf="vehicle?.driver" class="font-small">
      {{ vehicle?.driver }}
    </div>
    <div *ngIf="vehicle?.yearConstruction" class="sub-text">
      {{ "year_of_construction" | i18n }}: {{ vehicle?.yearConstruction }} -
      {{ vehicle?.codFuel }}
    </div>

    <div *ngIf="vehicle?.contractNumber" class="sub-text font-small">
      {{ "contract_number" | i18n }} {{ vehicle?.contractNumber }}
    </div>
    <div *ngIf="vehicle?.subText" class="font-small">
      {{ vehicle.subText }}
    </div>

  </div>
</div>

<ng-template #noDriver>
  <div class="flex flex-row justify-start items-center gap-[5px] no-driver">
    <mat-icon class="vehicle-colum-icon">warning</mat-icon>
    <span class="text">Driver non assegnato</span>
  </div>
</ng-template>